export default __webpack_public_path__ + "static/media/CA-9 Configuration saved pop-up.7f51fd05.png";